import type { StorageStrategy } from "./types";

/**
 * LocalStorage persistence strategy
 * Data persists across browser sessions and tabs
 */
export class LocalStorageStrategy implements StorageStrategy {
  private isAvailable(): boolean {
    if (typeof window === "undefined") return false;

    try {
      const testKey = "__storage_test__";
      window.localStorage.setItem(testKey, "test");
      window.localStorage.removeItem(testKey);
      return true;
    } catch {
      return false;
    }
  }

  get<T>(key: string): T | null {
    if (!this.isAvailable()) return null;

    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error("LocalStorage get error:", error);
      return null;
    }
  }

  set<T>(key: string, value: T): void {
    if (!this.isAvailable()) return;

    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error("LocalStorage set error:", error);
    }
  }

  remove(key: string): void {
    if (!this.isAvailable()) return;
    window.localStorage.removeItem(key);
  }

  clear(): void {
    if (!this.isAvailable()) return;
    window.localStorage.clear();
  }
}
